import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errorMessage, tokenFromHash } from "../lib/api";
import { useMe } from "../hooks/useMe";
import { Alert, Button } from "../components/Form";
import { PageHeader } from "../components/FeatureCard";
import { t } from "../lib/i18n";

const STASH = "pp_invite";

/** Invite link → (log in if needed) → redeem. Token kept in sessionStorage across the login hop. */
export function RedeemPage() {
  const { me, loading, reload } = useMe();
  const [token, setToken] = useState<string | null>(null);
  const [state, setState] = useState<"idle" | "busy" | "done">("idle");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fromHash = tokenFromHash();
    let tok = fromHash;
    try {
      if (fromHash) sessionStorage.setItem(STASH, fromHash);
      tok = fromHash ?? sessionStorage.getItem(STASH);
    } catch {
      /* ignore */
    }
    if (fromHash) history.replaceState(null, "", window.location.pathname);
    setToken(tok);
  }, []);

  async function redeem() {
    if (!token) return;
    setState("busy");
    setError(null);
    try {
      await api("/api/invitations/redeem", { method: "POST", json: { token } });
      try {
        sessionStorage.removeItem(STASH);
      } catch {
        /* ignore */
      }
      setState("done");
      reload();
    } catch (e) {
      setError(errorMessage(e));
      setState("idle");
    }
  }

  if (loading) return <p className="text-sm text-muted">{t("Memuatkan…")}</p>;

  return (
    <div className="mx-auto max-w-md space-y-4">
      <PageHeader title={t("Aktifkan lesen")} subtitle={t("Satu pautan, satu akaun, sekali guna.")} />
      {!token && <Alert kind="error">{t("Pautan pengaktifan tidak lengkap. Buka semula pautan dari emel anda.")}</Alert>}
      {token && state === "done" && (
        <>
          <Alert kind="success">{t("Lesen lifetime anda kini aktif. Selamat belajar!")}</Alert>
          <Link to="/" className="inline-block text-brand underline">{t("Ke laman utama")}</Link>
        </>
      )}
      {token && state !== "done" && !me && (
        <>
          <Alert kind="info">{t("Log masuk dengan emel yang sama digunakan semasa membeli untuk mengaktifkan lesen.")}</Alert>
          <Link to="/login?next=/redeem" className="inline-block rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-white">
            {t("Log masuk")}
          </Link>
        </>
      )}
      {token && state !== "done" && me && (
        <>
          <p className="text-sm">{t("Log masuk sebagai {email}.", { email: me.email })}</p>
          {error && <Alert kind="error">{error}</Alert>}
          <Button onClick={redeem} busy={state === "busy"} className="w-full">{t("Aktifkan lesen saya")}</Button>
        </>
      )}
    </div>
  );
}
